var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layerWrapper active",
      staticStyle: { display: "block" },
      attrs: { tabindex: "0" }
    },
    [
      _c(
        "div",
        {
          ref: "layerBox",
          staticClass: "cbox layerBox popWidM",
          style: Object.assign(
            {},
            { display: "block", opacity: "1" },
            _vm.style
          )
        },
        [
          _c("div", { staticClass: "cart-popup__dialog" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "cart-popup__item-link",
                staticStyle: { border: "none" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "bt-akl-blue btn_close NCAcmi_cont03_popup",
                    on: { click: _vm.closePopup }
                  },
                  [_vm._v("확인")]
                )
              ]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cart-popup__content payment" }, [
      _c(
        "div",
        {
          staticClass: "cart-popup__item-info amway-theme",
          staticStyle: { padding: "0" }
        },
        [
          _c("div", [
            _c("img", {
              staticStyle: { width: "100%" },
              attrs: {
                src: require("@/views/surveys/sapporo/images/activity/activity_infomation.jpg"),
                alt: "액티비티 안내"
              }
            })
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a0b71d4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a0b71d4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sapporo/components/SurveyPopupLayerActivity.vue
// module id = null
// module chunks = 